module.exports = __webpack_public_path__ + "media/images/logo-e421c4e9cc399a0e3d52b4bb403ab8b4.svg";